<template>
	<pre v-html="$t('terms.privacy_policy3')"></pre>
</template>

<script>
export default {
	name: 'PrivacyPolicy3',
};
</script>

<style scoped></style>
